export default __webpack_public_path__ + "static/media/analytics-white-db.30b66041.svg";